<template>
  <base-dialog v-model="isVisibleTemplateName">
    <dialog-template>

      <div
        slot="title"
        v-text="$t('saving.template.of.report')"
      />

      <div slot="content">
        <labeled-input
          v-model="templateName"
          :label="$t('template.name')"
          :placeholder="$t('new.template')"
        />
      </div>

      <simple-button
        slot="submit"
        variant="primary"
        :disabled="!isValidTemplateName"
        @click="handleSavingTemplate"
      >
        {{ $t('common.save') }}
      </simple-button>

      <simple-button
        slot="cancel"
        variant="transparent"
        @click="isVisibleTemplateName = false"
      >
        {{ $t('common.cancel') }}
      </simple-button>

    </dialog-template>
  </base-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import BaseDialog from 'molecules/base/Dialog';
import LabeledInput from 'molecules/common/LabeledInput';
import SimpleButton from 'molecules/common/SimpleButton';
import DialogTemplate from 'templates/DialogTemplate';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'ReportTemplateNameDialog',
  components: {
    BaseDialog,
    LabeledInput,
    SimpleButton,
    DialogTemplate,
  },
  created() {
    EVENT_BUS.$on('EVENT_RENAME_REPORT_TEMPLATE', this.showDialog);
  },
  beforeDestroy() {
    EVENT_BUS.$off('EVENT_RENAME_REPORT_TEMPLATE', this.showDialog);
  },
  data() {
    return {
      templateName: '',
      isVisibleTemplateName: false,
    };
  },
  computed: {
    isValidTemplateName() {
      return this.$validate.isNotEmptyString(this.templateName);
    },
    ...mapGetters('reports', ['getCurrentEditingTemplate']),
  },
  methods: {
    showDialog() {
      this.isVisibleTemplateName = true;
    },
    async handleSavingTemplate() {
      this.isVisibleTemplateName = false;

      // если текущий редактируемый шаблон отсутствует, бросаем событие EVENT_SAVE_TEMPLATE
      if (this.$validate.isNull(this.getCurrentEditingTemplate)) {
        EVENT_BUS.$emit('EVENT_SAVE_TEMPLATE', this.templateName);
        return;
      }

      try {
        await this.saveRenamedReportTemplate(this.templateName);
        this.templateName = '';

        this.$alert({
          type: 'success',
          text: 'notification.report.template.renamed.success',
        });
      } catch (error) {
        console.log(error);

        this.$alert({
          type: 'warning',
          text: 'notification.report.template.renamed.error',
        });
      }
    },
    ...mapActions('reports', ['saveRenamedReportTemplate']),
  },
};
</script>
